import React from "react";
import "../Styles/TermsNCondition.css";
import { Link } from "react-router-dom";

export default function TermsnCondition() {
  return (
    <>
      <div style={{ height: "108px" }}></div>

      <div className="tnc">
        <div className="container">
          <h3>TERMS & CONDITION</h3>
          <p>
            The following terms and conditions operate between Dokmen ("Dokmen",
            "we", "us", "our", "the company") and the user of this website
            ("you"). As a user of this website or a buyer of our products, you
            automatically agree to abide by these terms and conditions. If any
            changes to the same are made, they will be posted here. Hence, you
            are requested to check back in regularly. If at any point, the terms
            and conditions don’t suit you, we request you to not use the site or
            avail any of our services.
          </p>
          <p>Account</p>
          <ol>
            <li>
              If you make an account on this website, you will ensure that the
              information provided by you is complete, accurate, and true.
            </li>
            <li>
              Securing your display name and password is your responsibility as
              is the responsibility for the activities that happen under the
              display name.
            </li>
            <li>
              If we happen to find out that the information provided by you is
              untrue, inaccurate, false, misleading, or suspicious in any way,
              we shall disable your account and you will not be able to make any
              further purchases.
            </li>
            <li>
              We have the right to disable your account with no prior notice for
              no or any reason, including if you violate the Terms and
              Conditions written here in any measure.
            </li>
          </ol>

          <p>Products</p>
          <ol>
            <li>
              The images displayed on the website are for pictorial purposes
              only. Every effort has been made to ensure that they reflect the
              integrity of the actual product. However, depending upon the
              gadget you use and its screen, the actual item may be slightly
              different from the one being shown.
            </li>
            <li>
              We ensure that the prices of all the products are exact. However,
              in case of any error, we will correct the error asap. If an order
              had been placed, we will inform you of the error in price. If we
              are unable to contact you, the order stands canceled. If you
              cancel after paying for the items, we will send you a full refund.
            </li>
            <li>
              The prices of the products may change from time to time. However,
              for dispatched items, the price will remain the same as the
              displayed one.
            </li>
          </ol>

          <p>Payment</p>
          <ol>
            <li>
              Digitally, we accept all payments made through Razorpay. Apart
              from that, cash on delivery (COD) is also available.
            </li>
            <li>Razorpay accepts payments in INR only.</li>
          </ol>

          <p>Purchase, Orders, and Delivery</p>

          <ol>
            <li>
              No product purchased by you should be used for commercial
              purposes.
            </li>
            <li>
              On purchasing a product, the final acceptance of your order
              happens when we send you an email informing you of the dispatch of
              your order.
            </li>
            <li>
              You will be required to enter your phone number and email address
              while placing the order. These will be used to contact you in case
              of any delivery related updates
            </li>
            <li>
              The estimated time of delivery is calculated keeping in mind the
              best case scenario. The delivery may get delayed in case of
              unavailability of items or unforeseen travel complications during
              shipping.
            </li>
            <li>
              Products will be delivered to the address as given by you during
              checkout.
            </li>
            <li>
              Your address and phone number will be shared with the delivery
              company for the proper delivery of products.
            </li>
            <li>
              We take responsibility for the non-delivery of items only if you
              intimate us about the non-delivery within 10 days of the date when
              the order should have arrived.
            </li>
            <li>
              The number of items that we dispatch is the final number of items
              received by you unless you can furnish proof to the contrary.
            </li>
            <li>
              In case the item is delivered to a third party address, Dokmen is
              not responsible for the delivery of goods to your address after
              the item has been dropped off at the specified address.
            </li>
          </ol>

          <p>Shipping</p>

          <p>
            We always strive to deliver your products to you in the fastest time
            possible and in the best possible condition. The following are the
            stipulations in relation to our shipping services:
          </p>

          <ol>
            <li>
              Shipping charges will vary according to the place that the product
              is being delivered to. They will be visible when you are at
              checkout and are confirming your order.
            </li>
            <li>
              In case of replacement, the shipping charges will be on us- both
              when you send back the faulty item and when we send you the
              replacement. The item being sent back must be with the invoice and
              must be unused with all the labels and packaging intact.
            </li>
          </ol>

          <p>Privacy Policy</p>
          <p>
            Our detailed privacy policy can be found
            <Link to="/privacypolicy"> here.</Link>
          </p>

          <p>Intellectual Property Rights</p>

          <ol>
            <li>
              The website may be used for personal and non-commercial purposes
              only. The material can be downloaded from the website for the same
              purposes.
            </li>
            <li>
              All of the intellectual property rights, as well as the features
              and content on the website (text, audio, video, font, colors,
              images, design, icons, illustrations), are with Dokmen.
            </li>
            <li>
              You will not use any material on the website for commercial
              purposes without our express permission. Nothing is to be
              reproduced, replicated, distributed, modified, or republished.
            </li>
            <li>
              If you are found to have engaged in any of the above activities,
              your access to the website will be terminated. The materials
              produced or used by you have to be returned to us. Our team can
              and will take legal action if you violate our IPR terms.
            </li>
          </ol>

          <p>Website Use</p>

          <p>
            Your use of the website shall be governed by the following rules:
          </p>
          <ol>
            <li>
              You agree not to meddle with the working of the website using any
              device, software, or routine.
            </li>
            <li>
              You agree not to interfere with another person’s usage of the
              website or any ongoing transaction using any device, software, or
              routine.
            </li>
            <li>
              You shall not attempt to gain unauthorized access to the website
              or any of its servers through any illegal means like hacking or
              password mining among others.
            </li>
            <li>
              You shall not copy content from the website without the express
              permission of Dokmen.
            </li>
            <li>
              You shall not seek to harm or exploit anyone by asking for
              personally identifiable information.
            </li>
            <li>
              You shall not upload, display, modify or in any way have anything
              to do with another user’s personal information.
            </li>
            <li>
              You shall not make defamatory, negative, or degrading comments
              about the brand name or the domain, and shall not carry out any
              action that tarnishes the reputation of Dokmen.
            </li>
          </ol>

          <p>Indemnification</p>
          <p>
            You agree to indemnify, defend and hold harmless the Company, its
            directors, officers, employees, consultants, agents, and affiliates,
            from any and all third party claims, liability, damages or costs
            arising from your use of this website, your breach of Terms and
            Conditions, or infringement of any intellectual property right.
          </p>

          <p>Law</p>

          <p>
            The Terms and Conditions mentioned here are made in the context of
            laws of India. In case of any dispute or conflict, the same shall be
            resolved in the courts of Mumbai.
          </p>

          <p>Limitation of Liability</p>
          <ol>
            <li>
              You take full responsibility for your use of the website. In case
              of any dissatisfaction with the website, the only solution is for
              you to stop using it.
            </li>
            <li>
              To the full extent permissible by law, Dokmen will not be
              accountable for any consequential, direct, indirect, incidental,
              exemplary, or retaliatory damages that result from content,
              materials, products, information, or your ability or inability to
              use the website. These consequences include but are not limited to
              loss of data, loss of revenue or profits or savings, personal
              injury, emotional agony, loss of business.
            </li>
            <li>
              Dokmen does not guarantee that your use of the website will be
              uninterrupted or hassle-free always. We also reserve the right to
              interrupt or cancel services at any time without any prior notice
              to you.
            </li>
            <li>
              All of the materials made available through the website are
              provided on “as is” and “as available” basis without any express
              or implied warranties.
            </li>
          </ol>
          <p>Termination</p>
          <p>
            You agree that Dokmen may deny you access to the website at any
            time, should we determine that you have violated the Terms and
            Conditions or other policies in any way. If you or Dokmen terminates
            your use of services, you are still liable to pay for the order you
            placed.
          </p>

          <p>Contact Us</p>
          <p>
            For more information about our ‘Terms and Conditions’, if you have
            questions, or if you would like to make a complaint, please contact
            us by email at empirefootwear@gmail.com.
          </p>
        </div>
      </div>
    </>
  );
}
